let firstSlideImage = document.getElementById('1').src;

function setSlide(e, slider){
  let dots = document.getElementsByClassName('slider-dot');
  for (let i = 0; i<dots.length; i++){
    if(dots[i].classList.contains('active')){
      dots[i].classList.remove('active');
    };
  }
  e.target.classList.add("active");
  if(slider == 1){
     document.getElementById('1').src = firstSlideImage;
  }
  else{
    document.getElementById('1').src = document.getElementById(slider).src;
  }
 }

/* Removes autogenerated pagination link characters between page & = */
function fixPagination(){
  let paginate = document.querySelector('.paginate-container').children;
  for (const page of paginate) {
  let link = page.children[0];

  if (typeof link === 'object') {
    let str = link.href;
    // str = str.replace(/page_[^=]+/g, 'page');
    page.children[0].href = str+'#Projects';
  }
}
}

window.onload = (event) => {
  fixPagination();
};